import { TrackedQuery } from '@ih/app/client/shared/interfaces';

export class SetNotifications {
  public static readonly type = '[Notifications] SetNotifications';
  constructor(public readonly trackedQueries: TrackedQuery[]) {}
}
